import { Component, OnInit, inject } from "@angular/core";
import { AuthGuardedPage } from "../authGuardedPage";
import { Appointment, CommonService, ChecklistTemplate, SchedulingStateModel, GetAppointmentById, GetCalendarItems, GetServiceLevelsForTeamIds,  BackEndCalendarEvent, TeamMember, GetSchedulableItemsForTeam, SchedulableItem, SchedulableItemPage, ServiceLevelServices, PractitionerGroupEntity, PractitionerGroupStateModel, GetChecklistTemplates, CompassStateModel,  SchedulingStateStore } from 'huddyapi';
import { Select, Store } from "@ngxs/store";
import { Observable, Subscription, timer } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { EditCalendarEventDialog } from "../components/edit-calendar-event-dialog/edit-calendar-event-dialog.component";
import { CalendarBackEndPair } from "./calendar-view/calendar-view";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { CommunityConfigService, UserTeam } from "../services/community-config.service";
import { Util } from "../components/util";


@Component({
  selector: 'app-work-queue',
  templateUrl: './todo.component.html',
  styleUrls: ['./todo.component.scss'],
  providers : [SchedulingStateStore]
})
export class TodoComponent  extends AuthGuardedPage implements OnInit{
  readonly schedulingStateStore = inject(SchedulingStateStore);
  static currentTeamId : number = -1;
  userSubscription: any;
  practitionerGroupSubscription: any;
  user: any;
  tabIndex : number = 0;
  @Select(state => state.compassState) compassState$: Observable<CompassStateModel>;
  compassStateSubscription : Subscription;
  @Select(state => state.schedulingState) schedulingState$: Observable<SchedulingStateModel>;
  @Select(state => state.practitionerGroupState) practitionerGroupState$: Observable<PractitionerGroupStateModel>;
  schedulingStateSubscription : Subscription;
  calendarItems : BackEndCalendarEvent[];
  currentTeam : UserTeam;
  currentTeamItems : BackEndCalendarEvent[];
  practitionerGroup : PractitionerGroupEntity;
  checklistTemplates : ChecklistTemplate[];


  currentMembers : TeamMember[];
  currentTeamFired = false;
  serviceLevelsFired = false;
  loaded : boolean = true;
  search : string;
  offset: number;
  size : number;
  queuePage : SchedulableItemPage;
  sortField : string;
  sortDir : string;
  searchField : string = '';
  displayColumns : string[] = ['is_late_flag','itemType', 'startDateTime',  'expected', 'endDateTime', 'description', 'status', 'teamMember',  'familyIdentifier', 'familyPrimary',];
  currentServices : ServiceLevelServices[] ;
  calendarItemsRetrieved : boolean = false;


  constructor(
    public commonService : CommonService,
    public communityConfig : CommunityConfigService,
    public store : Store,
    public dialog : MatDialog,
    public matIconRegistry: MatIconRegistry,
    public domSanitizer: DomSanitizer

  ) {
    super(commonService);

    console.log('ENTERING TODO', this.currentTeamFired);
    this.matIconRegistry.addSvgIcon('search',  domSanitizer.bypassSecurityTrustResourceUrl('./assets/content-icon/ic-02.svg'));
  }


  ngOnInit(): void {
    this.userSubscription = this.commonService.getUserSubject().subscribe((user: any) => {
      console.log('got user', user);
      this.user = user || '';
      CommunityConfigService.currentTeamSubject.subscribe(team => {
        if (team) {
          const lastTeam = this.currentTeam;
          this.setCurrentTeam(team);
          console.log('currentTeamSubject.subscribe', this.user, lastTeam, team);
          if (this.user && this.user.email && ((team && !lastTeam) || (team.teamId != lastTeam.teamId))) {
            if (team.teamId < 0) {
              this.store.dispatch(new GetCalendarItems(this.user.email));
            } else {
              this.store.dispatch(new GetCalendarItems(this.user.email, team.teamId));
            }
            console.log('todo - all members', CommunityConfigService.allMembers);
          }
        }
      })

    });
    this.  schedulingStateSubscription  = this.schedulingState$.subscribe((schedulingState: SchedulingStateModel) => {

      if (schedulingState ) {
        console.log("before scheduled state subscribe", this.currentTeamFired);
        if (schedulingState.calendarItems && schedulingState.calendarItems.length > 0 ) {
          console.log("entering scheduled state subscribe");
            const workTimeSources : string[] = [ 'WorkingHours', 'Holiday', 'WorkingHoursNonWorkDay'];
            this.calendarItems = schedulingState.calendarItems;
            const workTimeItems : BackEndCalendarEvent[] = this.calendarItems.filter(item => workTimeSources.indexOf(item.sourceType) > -1);


            const teamIds : number[] = CommunityConfigService.userTeams.map(t => t.teamId).filter(teamId => teamId > 0);
            if (!this.serviceLevelsFired) {
              this.serviceLevelsFired = true;
              console.log('service levels fired');
              this.store.dispatch(new GetServiceLevelsForTeamIds(teamIds));
            }
            if (!this.loaded || !CommunityConfigService.hasCurrentTeam()) {
              CommunityConfigService.setCurrentTeam(CommunityConfigService.userTeams[0]);
            }
            console.log('setting currentteamitems', this.calendarItems);
            this.currentTeamItems = this.currentTeam.teamId == -1 ?
            this.calendarItems :
            this.calendarItems.filter(item => item.teamId === this.currentTeam.teamId);
        }

        if (schedulingState.schedulableItems) {
          this.queuePage = schedulingState.schedulableItems;
          console.log('queuepage.content', this.queuePage);
        }
        if ((!this.currentServices || this.currentServices.length === 0) && schedulingState.serviceLevelServices && schedulingState.serviceLevelServices.length > 0) {
          this.currentServices = schedulingState.serviceLevelServices;
        }

      }

    });

    this.compassStateSubscription = this.compassState$.subscribe((state: CompassStateModel) => {
      // console.log('got checklist templates', state.checklistTemplates);
      if (state.checklistTemplates && state.checklistTemplates.length > 0)
        this.checklistTemplates = [].concat(state.checklistTemplates);
    });
  }


  setCurrentTeam(team : UserTeam) {
    if (!this.currentTeam || (team.teamId != this.currentTeam.teamId)) {
      this.currentTeam = team;
      console.log('setCurrentTeam', this.currentTeam.teamId,team ? team.teamId : 'no event');

      this.offset = 0;
      this.size = 10;
      this.sortDir = 'desc';
      this.sortField = 'is_late_flag';
      this.search = '';

      this.getSchedulableItems();
      if (this.currentTeam.teamId > 0) {
        this.practitionerGroup = CommunityConfigService.fullTeams.find(pg => this.currentTeam.teamId == pg.id);
        if ((!this.checklistTemplates || this.checklistTemplates.length === 0) ||
          (this.checklistTemplates.length > 0 &&
          this.checklistTemplates[0].providerId != this.practitionerGroup.providerId)) {
          this.checklistTemplates = [];
          this.store.dispatch(new GetChecklistTemplates(this.practitionerGroup.providerId));
        }
      }
      TodoComponent.currentTeamId = this.currentTeam.teamId;
      this.currentMembers = this.currentTeam.teamId > 0 ? this.practitionerGroup.teamMembers : CommunityConfigService.allMembers;
  }


  }

  getSchedulableItems() {
    console.log('getSchedulableItems', this.currentTeam.teamId, this.offset, this.size, this.search, this.sortDir, this.sortField);

    this.store.dispatch(new GetSchedulableItemsForTeam(this.currentTeam.teamId, this.offset, this.size, this.search, this.sortDir, this.sortField));

  }


  getUserName() : string {

    let ret = '';
    if (this.user)
     ret = this.getName(this.user);
    return ret;
  }

  getName(user: any) {
    if(!user)
      return;
    if(user.firstName && user.lastName)
      return user.firstName + ' ' + user.lastName;
    return this.getShortName(user);
  }

  getShortName(user: any) {
    if(!user)
      return;
    if(user.firstName)
      return user.firstName;
    if(user.lastName)
      return user.lastName;
    if (user.email) {
        let index = user.email.indexOf('@');
        return index < 0 ? user.email : user.email.substring(0, index);
    }
    return "";
  }

  setTab(tabIndex: number) {
    this.tabIndex = tabIndex;
  }

  isLoading() : boolean {
    return !this.loaded;
  }

  isCoordinator() : boolean {
    return true;
  }


  getCalendarAction() : string {
    return (this.currentTeam && ['COORDINATOR', 'SCHEDULER'].indexOf(this.currentTeam.teamRole) > -1) ? 'Add' : 'Request';
  }

  editCalendarEvent(pair : CalendarBackEndPair) {
    console.log('editCalendarEvent', pair);
    let action: string  = this.getCalendarAction();
    if (pair) {
      pair.action = 'Edit'
      pair.username = this.user.login;
      pair.checklistTemplates = this.checklistTemplates;
      if (pair.backendEvent.sourceType === 'Appointment') {
        console.log('Appointment', pair);
        const id : number = +pair.backendEvent.id;
        this.store.dispatch(new GetAppointmentById(id)).subscribe (state => {
          const appointment : Appointment = this.schedulingStateStore.getCurrentAppointment();
          this.showEditDialog(pair, action, appointment);
        });
      } else {
        this.showEditDialog(pair, action);
      }

    } else {
      pair = {
        action: action,
        calendarEvent: undefined,
        backendEvent: undefined,
        username : this.user.login,
        checklistTemplates : this.checklistTemplates
      }
      this.showEditDialog(pair, action);
    }

  }

  showEditDialog(pair : CalendarBackEndPair, action : string, appointment? : Appointment) {
    console.log('pair', pair, 'appointment', appointment);
    const height: string = '650px';
    const dialog = this.dialog.open(EditCalendarEventDialog, {
      width: '600px',
      height: height,
      data: {
        pair: pair,
        currentTeam : this.currentTeam,
        currentMembers : this.currentMembers,
        appointment : appointment,
        serviceLevels : this.currentServices
      }
    });
    dialog.afterClosed().subscribe(t => {
      timer(1500).subscribe(fire => {
        this.store.dispatch(new GetCalendarItems(this.user.email, this.currentTeam.teamId));
        this.getSchedulableItems();
      });
    });
  }

  pageQueue($event) {
    if (this.size === $event.pageSize) {
      this.offset = $event.pageIndex * $event.pageSize;
    } else {
      this.offset = 0;
    }
    this.size = $event.pageSize;
    this.getSchedulableItems();
  }

  onClickItem(item: SchedulableItem, fieldName : string) {
    const key :string =  item.itemType + item.id;
    console.log('onClickItem', this.currentTeamItems);
    let backendEvents : BackEndCalendarEvent[] = this.currentTeamItems.filter(e => (e.sourceType + e.id) === key);
    let backendEvent : BackEndCalendarEvent = (backendEvents.length > 0) ? backendEvents[0] : undefined;
    if (!backendEvent) {

      backendEvent = {
        id : item.id,
        start: this.getDateFromSchedulableItem(item.startDateTime),
        end: this.getDateFromSchedulableItem(item.endDateTime),
        text: item.description,
        sourceType : 'Appointment',
        status :  item.status,
        teamId : this.currentTeam.teamId,
        teamMembers: item.teamMembers,
        appointmentType: item.appointmentType
      };
      console.log(backendEvent);
    }
    console.log(backendEvents, this.currentTeamItems);
    let action : string = this.getCalendarAction();
    if (action == 'Add') {
      action = 'Edit';
    }

    this.editCalendarEvent({
      action: 'Edit',
      calendarEvent: undefined,
      backendEvent : backendEvent
    });
  }

  getDateFromSchedulableItem(timeInSecs : number)  : Date {
      let ret = 60 * (new Date().getTimezoneOffset());
      ret = ret + timeInSecs;
      ret = ret * 1000;
      return new Date(ret);
  }

  getQueueItemValue(item : SchedulableItem, fieldName : string) :any {

    if (fieldName ==='itemType') {
      return (item.itemType === 'TimeOff') ? 'Time Off' : 'Appointment';
    } else if (fieldName ==='startDateTime') {
      let ret : number = 60 * (new Date().getTimezoneOffset());
      ret = ret + item.startDateTime;
      ret = ret * 1000;
      return ret;
    } else if (fieldName ==='endDateTime') {
      let ret : number = 60 * (new Date().getTimezoneOffset());
      ret = ret + item.endDateTime;
      ret = ret * 1000;
      return ret;
    } else if (fieldName ==='expected') {
      let ret : number = 60 * (new Date().getTimezoneOffset());
      ret = ret + item.expected;
      ret = ret * 1000;
      return ret;
    } else if (fieldName ==='description') {
      let ret : string = item.description;
      if (ret && ret.length > 50) {
        ret = ret.substring(0, 50) + '...';
      }
      return ret;
    } else if (fieldName ==='status') {
      if (item.status === 'TO_BE_SCHEDULED') {
        return 'To Be Scheduled';
      }
      return item.status;
    } else if (fieldName ==='teamMember') {
      return item.teamMember;
    } else if (fieldName ==='familyIdentifier') {
      return Util.sanitizeIdentifier(item.familyIdentifier, item.familyIdentifier);
    } else if (fieldName ==='familyPrimary') {
      return item.familyPrimary;
    }

    return '';
  }

  getQueueSize() : number {
    if (this.queuePage) {
      return this.queuePage.totalElements;
    }
    return 0;
  }

  checkSearchValue($event) {
    this.searchField = this.searchField.replace(/[^a-zA-Z0-9 '-.]/g, '');
  }

  doSearch($event) {

    this.offset = 0;
    console.log($event,this.searchField, $event.target.value);
    this.search = this.searchField;
    if (this.search.length > 3)
      this.getSchedulableItems();
  }

  changeSort($event) {
    console.log('change short', $event);
    //this.loading = true;
    this.sortField = $event.active;
    this.sortDir = $event.direction;
    this.getSchedulableItems();
  }

  clearSearchField() {
    this.searchField = '';
    this.search = '';
    this.getSchedulableItems();
  }

  getPageNumber() : number {
    let ret : number = 0;
    if (this.queuePage.number) {
      ret = this.queuePage.number;
    }
    return ret;
  }
}


